<div class="site-hierarchies-view-selector">
    <button (click)="hierarchyButtonClick()" class="btn btn-default hierarchy-btn">
        <span class="btn-title-wrapper">
            {{getBtnTitle()}}
        </span>
        <xux-icon class="icon-blue" icon="icon-arrow-down"></xux-icon>
    </button>
    <div *ngIf="showItemsList" class="site-hierarchies-list-wrapper">
        <div class="dropdown xux-dropdown open">
            <div class="dropdown-menu filter-dropdown-menu dropdown-menu-right">
                <div class="filter-dropdown-search-section view-area input-padding">
                    <div class="input-row input-row-with-icon">
                        <xux-icon icon="icon-search"></xux-icon>
                        <input type="text" [formControl]="searchControl" [placeholder]="I18n.Common.Filter | translate" />
                    </div>
                </div>

                <div class="hierarchies-items-wrapper view-area">
                    <div *ngFor="let item of itemsToDisplay">
                        <div class="hierarchy-btn-wrapper">
                            <button
                                [title]="item.name"
                                [disabled]="isDisabled(item)"
                                [class.selected]="isSelected(item)"
                                [class.disabled]="isDisabled(item)"
                                (click)="selectHierarchy(item)">
                                <xux-icon class="btn-icon-plus" icon="icon-plus"></xux-icon>
                                {{ item.name }}
                                <xux-icon class="btn-icon-hierarchy" icon="icon-hierarchy"></xux-icon>
                                <xux-icon class="btn-icon-close" icon="icon-close"></xux-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!itemsToDisplay.length">{{I18n.Common.NoItemsToDisplay | translate}}</div>
                </div>
                <div class="filter-dropdown-footer-section view-area">
                    <div class="btn-row">
                        <button class="btn btn-default btn-xs xux-btn" data-e2e-id="button-reset" (click)="resetClick()">
                          {{ I18n.Common.Reset | translate}}
                        </button>
                        <button class="btn btn-default btn-xs xux-btn" data-e2e-id="button-apply" (click)="applyClick()">
                          {{ I18n.Common.Apply | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
